import Head from 'next/head'
import { useRouter } from 'next/router'
import { FormEvent, useState } from 'react'
import { message } from 'antd'
import { uploadRule } from '@/lib/rulesApi'
import { DOMAINS, GAME_LABELS } from '@/lib/games'

const GAMES_BY_DOMAIN: Record<string, string[]> = {
  card: ['guandan', 'bridge', 'shuang_sheng', 'shuangkou', 'zhong_hua_qiao_pai', 'doudizhu'],
  ball: ['pickleball', 'tennis', 'badminton'],
}

export default function UploadRule() {
  const router = useRouter()
  const [domain, setDomain] = useState('card')
  const [submitting, setSubmitting] = useState(false)

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const fd = new FormData(e.currentTarget)
    if (!(fd.get('file') as File)?.size) {
      message.warning('请选择文件')
      return
    }
    setSubmitting(true)
    const res = await uploadRule(fd)
    setSubmitting(false)
    if (res.ok) {
      message.success('已提交，等待审核')
      router.push('/rules/mine')
    } else {
      message.error(res.message || '上传失败')
    }
  }

  return (
    <>
      <Head>
        <title>上传规则 · 灵缇规则库</title>
      </Head>
      <div className="min-h-screen bg-gray-50">
        <div className="mx-auto max-w-xl px-4 py-8">
          <h1 className="mb-6 text-2xl font-black text-gray-900">上传规则</h1>
          <form onSubmit={onSubmit} className="space-y-4 rounded-2xl bg-white p-6 shadow-sm">
            <input
              name="title"
              required
              placeholder="规则名称"
              className="w-full rounded-lg border border-gray-200 px-3 py-2"
            />
            <div className="flex gap-3">
              <select
                name="domain"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
                className="flex-1 rounded-lg border border-gray-200 px-3 py-2"
              >
                {DOMAINS.map((d) => (
                  <option key={d.key} value={d.key}>
                    {d.label}
                  </option>
                ))}
              </select>
              <select name="game" className="flex-1 rounded-lg border border-gray-200 px-3 py-2">
                {GAMES_BY_DOMAIN[domain].map((g) => (
                  <option key={g} value={g}>
                    {GAME_LABELS[g]}
                  </option>
                ))}
              </select>
            </div>
            <select name="category" className="w-full rounded-lg border border-gray-200 px-3 py-2">
              <option value="provincial">地方</option>
              <option value="event">赛事规程</option>
              <option value="official_national">国家官方</option>
              <option value="world">世界</option>
              <option value="institutional">配套制度</option>
            </select>
            <textarea
              name="summary"
              placeholder="简介（可选）"
              className="w-full rounded-lg border border-gray-200 px-3 py-2"
              rows={3}
            />
            <input type="file" name="file" accept=".pdf,.jpg,.jpeg,.png" required className="w-full text-sm" />
            <p className="text-xs text-gray-400">支持 PDF / 图片；提交后经管理员审核通过即公开。</p>
            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-lg bg-brand py-2.5 font-medium text-white hover:bg-brand-dark disabled:opacity-50"
            >
              {submitting ? '提交中…' : '提交审核'}
            </button>
          </form>
        </div>
      </div>
    </>
  )
}
